import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {withExperiments} from 'wix-experiments-react';
import get from 'lodash/get';
import {serverApi} from 'chat-widget-common';
import UploadBar from '../UploadBar/UploadBar';

class ImageAttachment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      url: null
    };
  }

  componentWillReceiveProps(nextProps) {
    const {uploading} = this.props;
    if (!nextProps.uploading && uploading) {
      this.setDownloadUrlFromServer(nextProps.media);
    }
  }

  setDownloadUrlFromServer(media) {
    const {height, width, url} = media;
    const isFileId = !/^(http|https):\/\//.test(url);
    if (isFileId) {
      const fillWidth = 200;
      const fillHeight = Math.floor(height * fillWidth / width);
      serverApi.getAttachment({url, width: fillWidth, height: fillHeight})
        .then(res => {
          const {url, resizedUrl} = res;
          this.setState({url, resizedUrl});
          this.loadImageAndScrollToBottom(resizedUrl);
        });
    } else {
      this.setState({url, resizedUrl: url});
      this.loadImageAndScrollToBottom(url);
    }
  }

  loadImageAndScrollToBottom(resizedUrl) {
    const img = new Image();
    img.addEventListener('load', () => {
      this.props.scrollToBottom();
    }, false);
    img.src = resizedUrl;
  }

  componentDidMount() {
    const {media, uploading} = this.props;
    const {file} = media;

    if (file) {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        this.setState({
          imagePreviewUrl: reader.result
        });
        this.props.scrollToBottom();
      });
      reader.readAsDataURL(file);
    }

    if (!uploading) {
      this.setDownloadUrlFromServer(media);
    }
  }

  render() {
    const {uploading, chatSettings, media} = this.props;
    const {url, resizedUrl, imagePreviewUrl} = this.state;

    const imgStyle = {
      borderRadius: get(chatSettings, 'design.selectedRadiusOption') + 'px'
    };

    const img = <img src={imagePreviewUrl ? imagePreviewUrl : resizedUrl}/>;
    return url || imagePreviewUrl ? (
      <div className="image-container">
        <div className="image" style={imgStyle}>
          {uploading ? <span className="uploading"> {img} <UploadBar percentCompleted={media.percentCompleted}/> </span> : <a href={url} target="_blank" rel="noopener noreferrer">{ img }</a>}
        </div>
      </div>
      ) : null;
  }
}

ImageAttachment.propTypes = {
  media: PropTypes.object,
  uploading: PropTypes.bool,
  chatSettings: PropTypes.object,
  scrollToBottom: PropTypes.func
};

function mapStateToProps(state) {
  return {
    chatSettings: state.chatSettings
  };
}

export default withExperiments(connect(mapStateToProps)(ImageAttachment));



// WEBPACK FOOTER //
// ./chat-app/components/Image/Image.js